import './MobileSheet.scss';

import {CloseOutlined} from '@ant-design/icons';
import {Drawer} from 'antd';
import cn from 'classnames';
import React, {useCallback, useId, useState} from 'react';

import useMenuScrollContainment from '../../hooks/useMenuScrollContainment';

const MobileSheet = ({open, onClose, title, closeLabel, children, extra, className}) => {
    const titleId = useId();
    const [panel, setPanel] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const panelRef = useCallback(
        (node) => {
            setPanel(node);
            node?.closest('[role="dialog"]')?.setAttribute('aria-labelledby', titleId);
        },
        [titleId]
    );

    useMenuScrollContainment(panel, open || isVisible);

    return (
        <Drawer
            open={open}
            placement='bottom'
            onClose={onClose}
            afterOpenChange={setIsVisible}
            rootClassName={cn('mobile-ui-sheet', className)}
            height='56vh'
            zIndex={1100}
            autoFocus={false}
            destroyOnClose
            title={<h2 id={titleId}>{title}</h2>}
            closable={false}
            extra={
                <div className='mobile-ui-sheet-actions'>
                    {extra}
                    <button
                        type='button'
                        className='mobile-ui-sheet-close ant-drawer-close'
                        aria-label={closeLabel}
                        onClick={onClose}
                    >
                        <CloseOutlined aria-hidden />
                    </button>
                </div>
            }
        >
            <div ref={panelRef} className='mobile-ui-sheet-body'>
                {children}
            </div>
        </Drawer>
    );
};

export default MobileSheet;
